/**
 * TikTok Seller Create Product 发品页能力开关。
 * 与 Temu bg.goods.add 半托货品页字段解耦：隐藏/跳过 Temu 独有项，保留 TTS 等价区域。
 */

/** 当前正式发品走 TTS OpenAPI Create Product */
export const TIKTOK_PUBLISH_USES_TTS_CREATE_PRODUCT = true;

/**
 * Temu 半托货品专有（TTS Create Product 无对应或不应强校验）→ UI 隐藏。
 */
export const TIKTOK_PUBLISH_HIDE = {
  /** 独立英文名 productI18nReqs */
  titleEn: true,
  /** 产地 / 省份 / 产地证明 */
  productOrigin: true,
  /** 1:1 素材图 materialImgUrl */
  materialImage: true,
  /** 货品模特 goodsModelReqs */
  goodsModels: true,
  /** 电子说明书 guideFiles */
  guideFiles: true,
  /** SKC 货号强校验（可用 external_product_id，不强制） */
  skcSupplierCodeRequired: true,
  /** 敏感属性 / 净重 / SKU 分类件数 / 独立包装 / 包装清单 */
  temuSkuPackageExtras: true,
  /** 外包装形状、类型、外包装图 */
  outerPackage: true,
  /** 半托上架站点列表 */
  listingSites: true,
  /** 承诺发货时效 shipmentLimitSecond */
  shipmentLimit: true,
};

/**
 * TTS 保留并强化的区域。
 */
export const TIKTOK_PUBLISH_KEEP = {
  basic: ['category', 'title', 'description', 'brand', 'templates'],
  attrs: ['categoryAttributes'],
  spec: ['salesAttributes', 'mainImages', 'detailImages', 'video', 'sellerSku', 'price', 'stock', 'sizeChart', 'printImagesLocal'],
  package: ['weight', 'dimensions'],
  sales: ['warehouse', 'shippingTemplate'],
};

export function isTiktokTtsPublishMode() {
  return TIKTOK_PUBLISH_USES_TTS_CREATE_PRODUCT === true;
}

export function hideTiktokPublishField(key) {
  if (!isTiktokTtsPublishMode()) return false;
  return Boolean(TIKTOK_PUBLISH_HIDE[key]);
}
